import { render, staticRenderFns } from "./truckingRegister.vue?vue&type=template&id=290e7310"
import script from "./truckingRegister.vue?vue&type=script&lang=js"
export * from "./truckingRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports